// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.renterprofile.dto.SatelliteRenterProfileCompletenessType

export enum SatelliteRenterProfileCompletenessType {
  COMPLETE = 'COMPLETE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  PARTIALLY_COMPLETE = 'PARTIALLY_COMPLETE',
}

export const SatelliteRenterProfileCompletenessType_values = [
  SatelliteRenterProfileCompletenessType.COMPLETE,
  SatelliteRenterProfileCompletenessType.NOT_AVAILABLE,
  SatelliteRenterProfileCompletenessType.PARTIALLY_COMPLETE,
] as const;
